export { GenderMenu } from "./gender-menu";
